import { render, staticRenderFns } from "./PoLineItemsList.vue?vue&type=template&id=50c9645b&scoped=true"
import script from "./PoLineItemsList.vue?vue&type=script&lang=js"
export * from "./PoLineItemsList.vue?vue&type=script&lang=js"
import style0 from "./PoLineItemsList.vue?vue&type=style&index=0&id=50c9645b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c9645b",
  null
  
)

/* custom blocks */
import block0 from "./PoLineItemsList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports